<div class="ci-field-container" *ngIf="!isLoadingAvailableCiTypes && !isLoadingLabels">
	<div class="header-wrap">
		<span class="tab selected">{{ labels.lbl_criacao_campo_cmdb }}</span>
	</div>
	<div class="body-wrap">
		<div
			class="button"
			[ngClass]="{ selected: fieldLevel === 'cmdb' }"
			(click)="fieldLevel = 'cmdb'; selectedCiType = ''; getCiFields()"
			*ngIf="PermissionService.hasPermission('register_cmdb_field_can_edit')">
			{{ labels.lbl_asset_inventario }}
		</div>
		<div
			class="button"
			[ngClass]="{ selected: fieldLevel === 'ci' }"
			(click)="fieldLevel = 'ci'; selectedCiType = ''; resetFields()"
			*ngIf="PermissionService.hasPermission('register_ci_field_can_edit')">
			{{ labels.lbl_asset_campos_extras }}
		</div>
		<div
			class="button"
			[ngClass]="{ selected: fieldLevel === 'customfield' }"
			(click)="fieldLevel = 'customfield'; selectedCiType = ''; resetFields()"
			*ngIf="PermissionService.hasPermission('register_custom_field_can_edit')">
			{{ labels.lbl_geral_campos_customizados }}
		</div>

		<div class="dotted-input-container" *ngIf="fieldLevel === 'ci' || fieldLevel === 'customfield'">
			<span>{{ labels.lbl_asset_tipo_ci }}</span>
			<select (change)="resetFields(); this.selectedCiType = $event.target.value; selectedField.id = '-1'; getCiFields()">
				<option [value]="''" [selected]="selectedCiType === ''">{{ labels.lbl_geral_selecione }}</option>
				<option [value]="ciType.id" [selected]="selectedCiType === ciType.id" *ngFor="let ciType of availableCiTypes">
					{{ labels[ciType.label] ? labels[ciType.label] : ciType.type }}
				</option>
			</select>
		</div>

		<ng-container *ngIf="!isLoadingCiFields && ((selectedCiType && selectedCiType !== '') || fieldLevel === 'cmdb')">
			<div class="dotted-input-container" *ngIf="selectedField.id !== ''">
				<span>{{ labels.lbl_geral_campos }}</span>
				<cpi-input-with-autocomplete
					[availableOptions]="ciFieldsIAC"
					[minInputLength]="0"
					[cleanValues]="cleanValues"
					(onValueChange)="setSelectedField($event)">
				</cpi-input-with-autocomplete>
			</div>

			<ng-container *ngIf="fieldLevel === 'cmdb' && selectedField.id != '-1'">
				<cpi-generic-form-gen [setGenericForm]="availableCustomers"> </cpi-generic-form-gen>
			</ng-container>

			<ng-container
				*ngIf="
					selectedField.id != '-1' &&
					((fieldLevel === 'ci' && PermissionService.hasPermission('register_ci_field_all_customers')) ||
						fieldLevel === 'customfield')
				">
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_nome }} *</span>
					<input [value]="selectedField.name" (input)="selectedField.name = formatValidName($event.target.value)" />
				</div>
				<div class="dotted-input-container">
					<span>Label *</span>
					<cpi-input-with-autocomplete
						[availableOptions]="labelLoadIAC"
						[setValue]="selectedField.label"
						[setInputText]="selectedField.label"
						[minInputLength]="3"
						[placeholder]="labels.lbl_iac_min_char_search.replace('$__$', '3')"
						(getInputText)="selectedField.label = $event"
						(onValueChange)="selectedField.label = $event">
					</cpi-input-with-autocomplete>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_tipo }} *</span>
					<select [value]="selectedField.inputType" (change)="changeInputType($event.target.value)">
						<option [value]="''">{{ labels.lbl_geral_selecione }}</option>
						<option
							[value]="'string'"
							[selected]="selectedField.inputType === 'string' || selectedField.inputType === 'varchar'">
							{{ labels.lbl_geral_texto }}
						</option>
						<option [value]="'number'" [selected]="selectedField.inputType === 'int'">{{ labels.lbl_geral_numero }}</option>
						<option [value]="'money'" [selected]="selectedField.inputType === 'money'">{{ labels.lbl_geral_monetario }}</option>
						<option [value]="'date'" [selected]="selectedField.inputType === 'date'">{{ labels.lbl_geral_data }}</option>
						<option [value]="'select'" [selected]="selectedField.inputType === 'select'">
							{{ labels.lbl_geral_listagem }}
						</option>
						<option [value]="'bit'" [selected]="selectedField.inputType === 'boolean' || selectedField.inputType === 'bit'">
							{{ labels.lbl_explain_booleano }}
						</option>
						<!---<option [value]="'period-date'" [selected]="selectedField.inputType === 'period-date'">{{labels.lbl_geral_periodo}}</option>--->
						<option [value]="'multi-select'" [selected]="selectedField.inputType === 'multi-select'">
							{{ labels.lbl_selecao_multipla }}
						</option>
						<option [value]="'textarea'" [selected]="selectedField.inputType === 'textarea'">
							{{ labels.lbl_geral_caixa_texto }}
						</option>
						<option [value]="'multi-input'" [selected]="selectedField.inputType === 'multi-input'">
							{{ labels.lbl_multiplos_campos }}
						</option>
					</select>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_mandatory }} *</span>
					<select (change)="selectedField.required = $event.target.value">
						<option [value]="false" [selected]="selectedField.required.toString() === 'false'">
							{{ labels.lbl_geral_nao }}
						</option>
						<option [value]="true" [selected]="selectedField.required.toString() === 'true'">{{ labels.lbl_geral_sim }}</option>
					</select>
				</div>

				<cpi-generic-form-gen [setGenericForm]="availableCustomers" *ngIf="fieldLevel === 'ci'"> </cpi-generic-form-gen>

				<cpi-generic-form-gen [setGenericForm]="multiInputForm" *ngIf="selectedField.inputType === 'multi-input'">
				</cpi-generic-form-gen>

				<div class="select-container" *ngIf="selectedField.inputType === 'select' || selectedField.inputType === 'multi-select'">
					<div class="title-label">
						<span>{{ labels.lbl_itens_da_listagem }}:</span>
						<span [title]="labels.lbl_tip_select_container_ciFieldRegister">
							<fa-icon [icon]="icons.faExclamationCircle"></fa-icon>
						</span>
					</div>
					<textarea rows="4" [value]="selectedField.values[0]" (input)="selectedField.values[0] = $event.target.value">
					</textarea>
				</div>

				<ng-container *ngFor="let field of multiInputForm[0].values; let index = index">
					<div class="select-container" *ngIf="field[2] === 'select'">
						<div class="title-label">
							<span>{{ labels.lbl_itens_da_listagem }} ({{ field[0] }}):</span>
							<span [title]="labels.lbl_tip_select_container_ciFieldRegister">
								<fa-icon [icon]="icons.faExclamationCircle"></fa-icon>
							</span>
						</div>
						<textarea
							rows="4"
							[value]="selectedField.subfield_items[index] ? selectedField.subfield_items[index] : ''"
							(input)="selectedField.subfield_items[index] = $event.target.value">
						</textarea>
					</div>
				</ng-container>
			</ng-container>

			<ng-container *ngIf="duplicateField && fieldLevel === 'customfield'">
				<cpi-generic-form-gen [setGenericForm]="duplicateFields"> </cpi-generic-form-gen>
			</ng-container>

			<!---
            <div class="button-container">
                <div class="button" [ngClass]="{'disabled' : isDeletingField || isUpdatingField}" (click)="confirmDeleteField.classList.contains('confirmClick') ? deleteField() : confirmButton(confirmDeleteField)" *ngIf="selectedField.id != '-1' && selectedField.id != '' && ((fieldLevel === 'customfield' && PermissionService.hasPermission('register_custom_field_can_delete')) || (fieldLevel === 'ci' && PermissionService.hasPermission('register_ci_field_can_delete')))" #confirmDeleteField>{{labels.lbl_geral_excluir}} <cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isDeletingField"></cpi-dot-bounce-loading-effect> </div>
                
                <div 
                class="button" 
                [ngClass]="{'disabled' : isCreatingField || isUpdatingField}" 
                (click)="resetFields(); selectedField.id = ''" 
                *ngIf="
                selectedCiType 
                && selectedField.id != '-1'
                && selectedField.id != ''
                && !isLoadingCiFields 
                && (
                    (fieldLevel === 'customfield' && PermissionService.hasPermission('register_custom_field_can_create'))
                    || (fieldLevel === 'ci' && PermissionService.hasPermission('register_ci_field_can_create'))
                )">
                    {{labels.lbl_geral_adicionar_novo}}
                </div>
                
                
            </div>
            --->
		</ng-container>

		<div class="button-container">
			<button
				[ngClass]="{ red: duplicateField }"
				(click)="duplicateField = !duplicateField"
				*ngIf="selectedField.id != '-1' && selectedField.id !== '' && fieldLevel === 'customfield'">
				{{ labels.lbl_duplicar_em_outro_tipo_de_ci }}
			</button>

			<button
				(click)="resetFields(); selectedField.id = ''"
				*ngIf="
					selectedCiType &&
					selectedField.id === '-1' &&
					!isLoadingCiFields &&
					((fieldLevel === 'customfield' && PermissionService.hasPermission('register_custom_field_can_create')) ||
						(fieldLevel === 'ci' && PermissionService.hasPermission('register_ci_field_can_create')))
				">
				{{ labels.lbl_geral_adicionar_novo }}
			</button>

			<ng-container
				*ngIf="
					selectedField.id === '' &&
					((fieldLevel === 'customfield' && PermissionService.hasPermission('register_custom_field_can_create')) ||
						(fieldLevel === 'ci' && PermissionService.hasPermission('register_ci_field_can_create')))
				">
				<button [ngClass]="{ disabled: isCreatingField }" (click)="isCreatingField ? null : (selectedField.id = '-1')">
					{{ labels.lbl_geral_cancelar }}
				</button>
				<button [ngClass]="{ disabled: isCreatingField }" (click)="createField()">
					{{ labels.lbl_geral_registrar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isCreatingField"></cpi-dot-bounce-loading-effect>
				</button>
			</ng-container>

			<button
				[ngClass]="{ disabled: isUpdatingField || isDeletingField }"
				(click)="updateField()"
				*ngIf="selectedField.id != '-1' && selectedField.id !== ''">
				{{ labels.lbl_geral_atualizar }}
				<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdatingField"></cpi-dot-bounce-loading-effect>
			</button>
		</div>

		<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'" *ngIf="isLoadingCiFields"></cpi-dot-bounce-loading-effect>
	</div>

	<cpi-dot-bounce-loading-effect
		[color]="'var(--primary-color-1)'"
		*ngIf="isLoadingAvailableCiTypes || isLoadingLabels"></cpi-dot-bounce-loading-effect>
</div>
